import React, { useState, useEffect } from 'react';
import styles from './Loan.module.css';
import selectGender_icon from '../../../../images/icons/UserKycIcons/selectGender_icon.svg';

function CommonLoanPurpose({
  id,
  sendUrl,
  sendloanType,
  randomColor,
  handleSelectData,
  setShow,
  loneTypeID
}) {
  const { each_box, text, box, icon_style } = styles;

  return (
    <div className={`${box}`}>
      <img
        src={selectGender_icon}
        className={`${id === loneTypeID ? icon_style : 'hidden'}`}
      />

      <div
        onClick={e => {
          handleSelectData();
          if (id === 7) setShow(false);
          else setShow(true);
          if (id != 8) setShow(true);
        }}
        className={`${each_box}`}
        style={{
          backgroundColor: randomColor.bgcolor,
          border: id === loneTypeID ? '1px solid #00ACB8' : ''
        }}
      >
        <div>
          <img src={sendUrl} alt="" />
        </div>
        <div className={`text-black-600 font-roboto font-normal`}>
          <div
            className={`${text}`}
            style={{
              color: randomColor.textcolor
            }}
          >
            {sendloanType}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CommonLoanPurpose;
